export default "__VITE_ASSET__ChXCt5tk__"